import { URL_ENDPOINTS } from "../../constants";
import { PaymentResponse } from "../../interfaces/Payment";
import { axiosInstance as Api } from "../../utils/api-helper";
import { PAYMENTS_URL } from "./../../constants/index";

const PaymentService = {
  getPaymentAuthorization: (
    creditProposalId: string,
    paymentMethod?: any
  ): Promise<PaymentResponse> => {
    const data = paymentMethod
      ? Object.assign(PAYMENTS_URL, { payment_method: paymentMethod })
      : PAYMENTS_URL;
    return Api.post(
      URL_ENDPOINTS.CREDIT_PROPOSAL + "/" + creditProposalId + "/payments",
      data
    );
  },
  getPaymentStatus: (
    creditProposalId: string,
    paymentId: string
  ): Promise<PaymentResponse> => {
    return Api.get(
      URL_ENDPOINTS.CREDIT_PROPOSAL +
        `/${creditProposalId}/payments/${paymentId}`
    );
  },
};

export default PaymentService;
